import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'sorted',
    pure: false,
    standalone: false
})
export class SortedPipe implements PipeTransform {

  transform<T>(value: T[], key: string|((a:T, b:T) => number) = 'sortindex', asc: boolean = true): T[] {
    if(typeof key === 'function'){
      value.sort(key);
    }
    else if(key) {
      value.sort((a, b) => {
        if (a[key] && b[key]) {
          return asc ? a[key] - b[key] : b[key] - a[key];
        } else if (a[key]) {
          return asc ? -1 : 1;
        } else if (b[key]) {
          return asc ? 1 : -1;
        }
        return 0;
      });
    }
    return value;
  }

}
